(function () {
  // Aparición al hacer scroll
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })
    : null;

  function initReveal(root) {
    root.querySelectorAll('[data-mt-reveal]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  // Partículas pixel
  function initParticles(root) {
    root.querySelectorAll('.mt-particles[data-count]').forEach(function (box) {
      if (box.dataset.done) return;
      box.dataset.done = '1';
      var n = parseInt(box.dataset.count, 10) || 0;
      for (var i = 0; i < n; i++) {
        var p = document.createElement('i');
        var s = [4, 6, 8][i % 3];
        p.style.left = Math.random() * 100 + '%';
        p.style.width = p.style.height = s + 'px';
        p.style.setProperty('--t', 7 + Math.random() * 9 + 's');
        p.style.setProperty('--dl', -Math.random() * 14 + 's');
        box.appendChild(p);
      }
    });
  }

  // Selector de colores y modos
  function initColores(root) {
    root.querySelectorAll('[data-mt-colores]').forEach(function (sec) {
      if (sec.dataset.done) return;
      sec.dataset.done = '1';
      var stage = sec.querySelector('[data-stage]');
      var label = sec.querySelector('[data-color-name]');
      sec.addEventListener('click', function (ev) {
        var sw = ev.target.closest('[data-color]');
        if (sw) {
          sec.querySelectorAll('[data-color]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          sw.setAttribute('aria-pressed', 'true');
          stage.style.setProperty('--sel', sw.dataset.color);
          if (label) label.textContent = sw.dataset.name;
          return;
        }
        var md = ev.target.closest('[data-mode]');
        if (md) {
          sec.querySelectorAll('[data-mode]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          md.setAttribute('aria-pressed', 'true');
          stage.dataset.anim = md.dataset.mode;
        }
      });
    });
  }

  // Galería de producto
  function initGaleria(root) {
    root.querySelectorAll('[data-mt-gallery]').forEach(function (g) {
      if (g.dataset.done) return;
      g.dataset.done = '1';
      var track = g.querySelector('[data-track]');
      var thumbs = g.querySelectorAll('[data-thumb]');
      function go(i) {
        var slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.dataset.thumb, 10)); });
      });
      var prev = g.querySelector('[data-prev]');
      var next = g.querySelector('[data-next]');
      function current() { return Math.round(track.scrollLeft / track.clientWidth); }
      if (prev) prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
      if (next) next.addEventListener('click', function () { go(Math.min(track.children.length - 1, current() + 1)); });
      track.addEventListener('scroll', function () {
        var i = current();
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }, { passive: true });
    });
  }

  // Barra fija de compra
  function initSticky(root) {
    root.querySelectorAll('[data-mt-sticky]').forEach(function (bar) {
      if (bar.dataset.done) return;
      bar.dataset.done = '1';
      var target = document.getElementById(bar.dataset.target);
      if (!target || !io) return;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
      }).observe(target);
    });
  }

  // Cantidad
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10);
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function initAll(root) {
    initReveal(root);
    initParticles(root);
    initColores(root);
    initGaleria(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
